module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{},"en":{"":""},"ca":{"":""}}')
  delete Component.options._Ctor
}
